import { useContext } from "react";
import { Navigate,useParams,useLocation } from "react-router-dom";
import { Contexto } from "../../Context/Contexto";
import { MensajeCont } from "../../Context/MensajeContext";

export default function PrivateRoute({children})
{
    const UrlBase="";
    const {Cli}=useContext(Contexto)
    const {SetRedireccionamiento}=useContext(MensajeCont)
    const location = useLocation();
    if(location.hash!="")
    {
        SetRedireccionamiento(location.hash)
    }

    
    if(Cli==undefined)
    {
        return <Navigate to="/login"></Navigate>;
    }else
    {
        if(Cli.lCasilla==undefined)
        {
                return <Navigate to="/login"></Navigate>;
        }
        else
        {
            if(Cli.lCasilla[0].ecode==undefined)
            {
                return <Navigate to="/login"></Navigate>;
            }
            else
            {
                if(Cli.lCasilla[0].ecode=="")
                {
                    return <Navigate to="/login"></Navigate>;
                }else
                {
                    return children;
                }
            }    
        }
    }
    

    
}